import React, { useEffect, useRef, useState } from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import { SpinnerTemplate } from '../components/templates/SpinnerTemplate'
import { CheckboxBlock } from '../components/organisms/CheckBoxBlock'
import { SubmitButton } from '../components/organisms/SubmitButton'
import { FormBlock } from '../components/organisms/FormBlock'
import { UiState, initialUiState } from '../types'
import { MarketoForm } from '../components/organisms/MarketoForm'
import { FooterDescription } from '../components/molecules/FooterBlock'
import { DemoHeaderDescription } from '../components/molecules/HeaderDescription/DemoHeaderDescription'

export const DemoPage = () => {
  const [isShowSpinner, setIsShowSpinner] = useState(false)
  const [isConsulRequestChecked, setIsConsulRequestChecked] = useState(false) // デフォルトではチェックを付けない
  const [uiState, setUiState] = useState<UiState>(initialUiState)

  const marketoFormRef = useRef<HTMLFormElement>(null)

  useEffect(() => {
    document.title = 'Airレジオーダーデモ同意画面'
  }, [])

  return (
    <SpinnerTemplate isShowSpinner={isShowSpinner}>
      <GlobalStyle />
      <Wrapper>
        <Contents>
          <DemoHeaderDescription />
          <CheckboxBlock
            value={isConsulRequestChecked}
            setValue={setIsConsulRequestChecked}
          />
          <FormBlock
            isShow={isConsulRequestChecked}
            state={uiState}
            setState={setUiState}
            marketoFormRef={marketoFormRef}
          />
          <SubmitButton
            buttonTitle="上記に同意し、デモモードを試す"
            trialMode="TRIALDEMO_HANDY"
            isConsulRequestChecked={isConsulRequestChecked}
            setShowSpinner={setIsShowSpinner}
            marketoFormRef={marketoFormRef}
            uiState={uiState}
            setUiState={setUiState}
          />
          <MarketoForm marketoFormRef={marketoFormRef} state={uiState} />
          <FooterDescription />
        </Contents>
      </Wrapper>
    </SpinnerTemplate>
  )
}

const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'Hiragino Kaku Gothic Pro';
    color: #606060;
    margin: 0;
  }
`

const Contents = styled.div`
  padding: 8px 16px 24px 16px;
  max-width: 500px; // iPadで表示しても不自然にならないように一応設定
  margin: auto;
  padding-bottom: 78px; // for Footer
`
const Wrapper = styled.div`
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
`
